import React, { useEffect,useState } from "react";
import axios from "axios";
import '../order/OrderList.css'
import { Link } from "react-router-dom"; // File untuk styling
import Pagination from 'react-bootstrap/Pagination';
import { useNavigate } from 'react-router-dom';


function NotificationConfigurationList() {
    const [tokenNow, setTokenNow] = useState('');
    const navigate = useNavigate();
    const [error, setError] = useState("");

    const [notificationConfigurations, setNotificationConfigurations] = useState([]);
    const resource = 'operation/notification-configuration-list';

    useEffect(() => {
      const storedToken = localStorage.getItem('token');
        setTokenNow(storedToken);

        const checkSessionToken = async () => {
          try {
            const response = await fetch(
              `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
                },
              }
            );
    
            if (!response.ok) {
              setError(data.message || "Failed to fetch session token data");
              throw new Error(data.message || "Failed to fetch session token data");
            }
    
            // Parse response text as a boolean value
            const text = await response.text();
            const data = text === "true";
    
            if (data) {
            } else {
              window.alert("Session is invalid");
              navigate("/login");
            }
          } catch (error) {
            console.error("Fetch Error:", error.message);
            setError("Fetch Error: " + error.message);
          }
        };
    
        checkSessionToken();

        defaultPage();
      }, []);

      function defaultPage(){
        loadNotificationConfigurationList();     
      }
    
    const loadNotificationConfigurationList = async (key,value1,value2) => {
        try {     
          const result = await axios.get(`https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/notification-configuration-list`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });
          const data = result.data;
          setNotificationConfigurations(data);    
        } catch (error) {
          console.error("Error loading order list:", error);
        }
      };

      //pagination
      const [currentPage, setCurrentPage] = useState(1);
      const ordersPerPage = 10;
    
      // Get current orders
      const indexOfLastOrder = currentPage * ordersPerPage;
      const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
      const currentNotificationConfigurations = notificationConfigurations.slice(indexOfFirstOrder, indexOfLastOrder);
    
      // Change page
      const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
      // Generate pagination items
      const pageNumbers = [];
      for (let i = 1; i <= Math.ceil(notificationConfigurations.length / ordersPerPage); i++) {
        pageNumbers.push(i);
      }

      const renderPaginationItems = () => {
        const paginationItems = [];
        let ellipsisShown = false;
    
        for (let i = 1; i <= pageNumbers.length; i++) {
          if (i === 1 || i === pageNumbers.length || (i >= currentPage - 2 && i <= currentPage + 2)) {
            paginationItems.push(
              <Pagination.Item
                key={i}
                active={i === currentPage}
                onClick={() => paginate(i)}
              >
                {i}
              </Pagination.Item>
            );
            ellipsisShown = false;
          } else if (!ellipsisShown) {
            paginationItems.push(<Pagination.Ellipsis key={`ellipsis-${i}`} />);
            ellipsisShown = true;
          }
        }
    
        return paginationItems;
      };

    return (
        <div className="container-order-list">
          {/*<update-code */}
          <input type="hidden" name="token" value={tokenNow} /> {/* Hidden token field */}
            {/* update-code>*/}
            <h1>Cross Connect Notification Configuration List</h1>
                <div className="title-order-input">                  
                    {error && <p className="error-message">{error}</p>}            
                </div>      
                         
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'5%'}}>Template Id</th>
                    <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'10%'}}>Category</th>
                    <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'15%'}}>Event</th>
                    <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'15%'}}>Template</th>
                    <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'50%'}}>Notes</th>
                    <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'5%'}}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentNotificationConfigurations.map((notifConfig) => (
                      <tr>  
                        <td>{notifConfig.notification_internal_email_template_id}</td>                  
                        <td>{notifConfig.category}</td>
                        <td>{notifConfig.event}</td>
                        <td>{notifConfig.template}</td>
                        <td>{notifConfig.notes}</td>
                        <td className="icon-center">
                          <Link to={`/operation/manage-email-destination?templateId=${notifConfig.notification_internal_email_template_id}`}>
                            <i className="bi bi-pencil-fill" title="Manage Email Destination"></i>
                          </Link>
                        </td>
                      </tr>
                  ))}
                </tbody>
              </table>

      <Pagination>
        <Pagination.First onClick={() => paginate(1)} />
        <Pagination.Prev
          onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
        />
        {renderPaginationItems()}
        <Pagination.Next
          onClick={() =>
            paginate(
              currentPage < pageNumbers.length ? currentPage + 1 : pageNumbers.length
            )
          }
        />
        <Pagination.Last onClick={() => paginate(pageNumbers.length)} />
      </Pagination>   
        </div>
    );
}

export default NotificationConfigurationList;
